var util = require("./util");
var PDFPage = require("./node-types/page");
var PDFNode = require("./node-types/node");
var PDFBlockNode = require("./node-types/block");
var PDFAbsoluteNode = require("./node-types/absolute");
var PDFColumnsNode = require("./node-types/columns");
var PDFTableNode = require("./node-types/table");
var PDFImageNode = require("./node-types/image");
var PDFCanvasNode = require("./node-types/canvas");
var PDFInlineBlockNode = require("./node-types/inline-block");
var PDFListItemNode = require("./node-types/list-item");
var PDFPageTemplate = require("./node-types/page-template");
var PDFSection = require("./node-types/section");
var PDFFieldNode = require("./node-types/field");
var PDFSVGNode = require("./node-types/svg");
function getPseudo(node, pseudo, parent, parentStyles) {
    //jshint ignore:line
    var pseudoKey = ":" + pseudo;
    var styles = parentStyles[pseudoKey] || {}; //styleManager.getDeclarations(node, pseudo);
    if (typeof styles.content === "string") {
        var content;
        try {
            content = JSON.parse(styles.content);
            if (typeof content !== "string")
                return;
        }
        catch (e) {
            return;
        }
        var pseudoNode = resolveNode(node, parent, styles, pseudo);
        var contentNode = new PDFNode({}, null, pseudoNode, content);
        pseudoNode.setChildren([contentNode]);
        return pseudoNode;
    }
}
function getAttrMap(node) {
    var attrList = node.attributes;
    var ret = {};
    for (var i = 0; i < attrList.length; i++) {
        ret[attrList[i].name] = attrList[i].value;
    }
    return ret;
}
function hasOwnProperty(obj, name) {
    return Object.prototype.hasOwnProperty.call(obj, name);
}
function resolveNode(node, parent, styles, pseudo) {
    if (styles.display === "none")
        return;
    var C = PDFNode;
    if (node.tagName && node.tagName.toLowerCase() === "pdf-page-content")
        C = PDFPageTemplate.PageContent;
    else if (node.tagName && node.tagName.toLowerCase() === "pdf-field")
        C = PDFFieldNode;
    else if (node.tagName && node.tagName.toLowerCase() === "svg")
        C = PDFSVGNode;
    else if (styles.display === "block")
        C = PDFBlockNode;
    else if (styles.display === "inline-block")
        C = PDFInlineBlockNode;
    else if (styles.display === "table")
        C = PDFTableNode;
    else if (styles.display === "list-item")
        C = PDFListItemNode;
    else if (styles.display === "table-cell")
        C = PDFTableNode.Cell;
    else if (styles.display === "table-row")
        C = PDFTableNode.Row;
    else if (styles.display === "table-row-group" ||
        styles.display === "table-header-group" ||
        styles.display === "table-footer-group") {
        C = PDFTableNode.RowGroup;
    }
    if (styles.position === "absolute")
        C = PDFAbsoluteNode;
    if (node.tagName && node.tagName.toLowerCase() === "pdf-columns")
        C = PDFColumnsNode;
    if (node.tagName && hasOwnProperty(styles, "-rm-pdf-columns"))
        C = PDFColumnsNode;
    if (node.tagName && node.tagName.toLowerCase() === "img")
        C = PDFImageNode;
    if (node.tagName && node.tagName.toLowerCase() === "canvas")
        C = PDFCanvasNode;
    var pdfNode = new C(node, pseudo, parent, null, styles, getAttrMap(node));
    return pdfNode;
}
function parseHelper(node, parent, styleManager) {
    var pdfNode;
    if (node.nodeType === 3)
        pdfNode = new PDFNode(node, null, parent, node.nodeValue);
    else if (node.nodeType === 1) {
        var styles = styleManager.getDeclarations(node);
        pdfNode = resolveNode(node, parent, styles);
        if (!pdfNode)
            return;
        var beforeNode = getPseudo(node, "before", pdfNode, styles);
        var afterNode = getPseudo(node, "after", pdfNode, styles);
        var children = [];
        if (beforeNode)
            children.push(beforeNode);
        Array.prototype.forEach.call(node.childNodes, function (child) {
            var pdfChild = parseHelper(child, pdfNode, styleManager);
            if (pdfChild)
                children.push(pdfChild);
        });
        if (afterNode)
            children.push(afterNode);
        pdfNode.setChildren(children);
    }
    return pdfNode;
}
function parsePage(node, styleManager, compress) {
    if (node.nodeType !== 1)
        throw new TypeError("Children of <rm-html-pdf> must be a <pdf-page>");
    var tagName = node.tagName.toLowerCase();
    if (tagName !== "pdf-page" && tagName !== "pdf-section" && tagName !== "pdf-page-template") {
        throw new TypeError("Children of <rm-html-pdf> must be a <pdf-page>");
    }
    var child, children = [], pdfPage;
    if (tagName === "pdf-page")
        pdfPage = new PDFPage(children, getAttrMap(node), compress);
    else if (tagName === "pdf-section")
        pdfPage = new PDFSection(children, getAttrMap(node), compress);
    else
        pdfPage = new PDFPageTemplate(children, getAttrMap(node));
    pdfPage.styles = styleManager.getDeclarations(node);
    for (var i = 0; i < node.childNodes.length; i++) {
        child = node.childNodes[i];
        if (child.nodeType !== 1)
            continue;
        var pdfChild = parseHelper(child, pdfPage, styleManager);
        if (pdfChild)
            children.push(pdfChild);
    }
    pdfPage.resolveStyles(styleManager);
    pdfPage.computeStyles(styleManager);
    return pdfPage;
}
function generate(rootNode, styleManager, compress) {
    if (rootNode.nodeType !== 1 || rootNode.tagName.toLowerCase() !== "rm-html-pdf")
        throw new TypeError("Root Node must be a <rm-html-pdf>");
    // console.time("page parse");
    var child, pages = [], currentPage;
    for (var i = 0; i < rootNode.childNodes.length; i++) {
        child = rootNode.childNodes[i];
        if (child.nodeType !== 1)
            continue;
        currentPage = parsePage(child, styleManager, compress);
        if (!(currentPage instanceof PDFPageTemplate) && currentPage.styles.display !== "none")
            pages.push(currentPage);
    }
    // console.timeEnd("page parse");
    // console.log("NODES", PDFNode.getCount());
    var numPages = 0;
    pages.forEach(function (page) {
        if (page instanceof PDFSection)
            numPages += page.getNumberOfPages();
        else
            numPages += 1;
    });
    PDFFieldNode.setValue("total-pages", numPages);
    // console.time("page generate");
    var pdf;
    pages.forEach(function (page, i) {
        if (!(page instanceof PDFSection) && i !== 0)
            page.addPage(pdf);
        pdf = page.generate(pdf);
    });
    // console.timeEnd("page generate");
    util.logTimes();
    return pdf;
}
module.exports = generate;
//# sourceMappingURL=module.js.map